export const Config = {
  KEY: 'DOGNUTRIENTCONTAINER',
  PETTYPE: 'DOG',
  ANIMATIONS: {
    IDLE: {
      frames: [5],
      frameRate: 5,
      repeat: 0,
    },
    EAT: {
      frames: [5, 6, 7, 8],
      frameRate: 5,
      repeat: 0,
    },
    DRINK: {
      frames: [0, 1, 2, 3, 4],
      frameRate: 5,
      repeat: 0,
    },
    IDLE2: {
      frames: [0],
      frameRate: 5,
      repeat: 0,
    },
  },
  ATTACHPOINTS: {
    MOUTH: {
      0: {
        x: -0.43,
        y: -0.08,
        scale: 0.05,
      },
    },
    NECK: {
      0: {
        x: -0.15,
        y: -0.04,
        scale: 0.085,
      },
    },
  },
};
